import constants from '../../ahm-constants';
import type { CustomExplainedTerm } from '../../pages/explained-term/detail/utils/format-data-for-content-tile/types';

const {
  URLS: {
    SALES: { EXPLAINED },
  },
} = constants;

const getLinkFromSanityTerm = ({ detailsTeaser, identifier, urlObject }: CustomExplainedTerm) => {
  const urlName = urlObject?.name;
  const url = urlObject?.url;

  if (urlName && url) {
    return { link: url, linkText: urlName };
  }

  const slug = identifier?.current;
  const ctaPath = slug ? `${EXPLAINED}/${slug}` : null;

  if (ctaPath && detailsTeaser) {
    return { link: ctaPath, linkText: detailsTeaser };
  }

  return null;
};

export default getLinkFromSanityTerm;
